module.exports = __webpack_public_path__ + "img/rishi.6a2229af.jpg";